import { useMemo } from "react";
import { countriesOf, nightsOf, type Trip } from "./content";
import { routePreviewHref } from "./links";
import LiveMap from "./LiveMap";
import { hostelMarker, hostelPoint } from "./mapModel";
import { Flag, MM_MONKEY } from "./ui";
import styles from "./MadMonkeyHome.module.scss";
import shared from "./MadMonkey.module.scss";

const cx = (...names: (string | false | undefined)[]) => names.filter(Boolean).join(" ");

/**
 * A ready-made route as a card: its route on a small live map, its name as the link (stretched over the whole
 * card). The first card on the home page is `big` and names its stops on the map; the others leave them bare.
 */
const TripCard = ({ trip, big = false }: { trip: Trip; big?: boolean }) => {
	const slugs = useMemo(() => trip.stops.map(([s]) => s), [trip]);
	const hostels = useMemo(() => slugs.map((s) => hostelMarker(s, { inRoute: true, plate: big })), [slugs, big]);
	const fit = useMemo(() => slugs.map(hostelPoint), [slugs]);

	return (
		<article className={cx(styles.tc, big && styles.big)}>
			<div className={styles.tcMap}>
				<LiveMap still id={`mm-trip-${trip.id}`} label={`Route map: ${trip.name}`} hostels={hostels} route={slugs} fit={fit} interactive={false} dots={false} />
				<span className={styles.ribbon}>
					<img src={MM_MONKEY} alt="" />
					{trip.tag}
				</span>
			</div>
			<div className={styles.tcBody}>
				<h3>
					<a className={styles.stretch} href={routePreviewHref(trip)}>
						{trip.name}
					</a>
				</h3>
				<p className={styles.sub}>{trip.vibe || trip.blurb}</p>
				{trip.vibes && (
					<div className={styles.vibes}>
						{trip.vibes.map((v) => (
							<span key={v}>{v}</span>
						))}
					</div>
				)}
				<div className={styles.meta}>
					<span className={shared.chip}>{nightsOf(trip)} nights</span>
					<span className={shared.chip}>{trip.stops.length} Mad Monkeys</span>
					<span className={shared.chip}>
						{countriesOf(slugs).map((c) => (
							<Flag key={c} cc={c} />
						))}
					</span>
				</div>
			</div>
		</article>
	);
};

export default TripCard;
